/* Form-family park: the drawer properties convert with the details-tab round (component-map.md). */
import { useFormControl } from '@chakra-ui/react';
import type { ContentEditableProps } from '@lexical/react/LexicalContentEditable';
import { FC } from 'react';

import { MarkdownEditor } from '../markdown';

type DrawerPropertyMarkdownProps = {
  defaultValue?: string | null;
  placeholder?: string;
  onSubmit?: (description: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  contentEditableProps?: ContentEditableProps;
};
export const DrawerPropertyMarkdown: FC<DrawerPropertyMarkdownProps> = ({
  defaultValue,
  placeholder,
  onSubmit,
  onBlur,
  onFocus,
  contentEditableProps,
}) => {
  const formControlProps = useFormControl({});
  const isEditable = !formControlProps.readOnly;
  const labelledBy = `${formControlProps.id}-label`;

  const handleSubmit = (value: string) => {
    if (value !== (defaultValue || '') && onSubmit) {
      onSubmit(value);
    }
    onBlur?.();
  };

  return (
    <MarkdownEditor
      defaultValue={defaultValue}
      config={{ editable: !!isEditable }}
      placeholder={placeholder}
      onBlur={handleSubmit}
      variant="property"
      contentEditableProps={{
        ...formControlProps,
        ariaLabelledBy: labelledBy,
        onFocus,
        ...contentEditableProps,
      }}
    />
  );
};
